import { render, staticRenderFns } from "./rightsDetail.vue?vue&type=template&id=d23e7bc2&scoped=true"
import script from "./rightsDetail.vue?vue&type=script&lang=js"
export * from "./rightsDetail.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=d23e7bc2&prod&scoped=true&lang=css&external"
import style1 from "./rightsDetail.vue?vue&type=style&index=1&id=d23e7bc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23e7bc2",
  null
  
)

export default component.exports